<template>
    <div v-if="!print" class="border border-primary card p-3 bg-light mb-3">
        <div class="card-header">
            <h3>{{ index+1 }}. előadás</h3>
            <button class="x-icon-delete" @click.prevent="deletePalyamunka" title="Előadás törlése"></button>
            <button class="x-icon-up" :disabled="index == 0" @click.prevent="upPalyamunka" title="Előadás feljebb csúsztatása"></button>
            <button class="x-icon-down" :disabled="index == jegyzokonyv.palyamunkak.length-1" @click.prevent="downPalyamunka" title="Előadás lejjebb csúsztatása"></button>
        </div>
        <div class="card-body">
            <div class="form-group mb-2">
                <div class="col-xs-2">
                    <label for="otdkraJavasolt">OTDK-ra javasolt</label>
                    <div class="form-check" id="otdkraJavasolt">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="otdkraJavasoltTrue" value="true" v-model="palyamunka.otdkraJavasolt" />
                            <label class="form-check-label" for="otdkraJavasoltTrue">Igen</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" id="otdkraJavasoltFalse" value="false" v-model="palyamunka.otdkraJavasolt" />
                            <label class="form-check-label" for="otdkraJavasoltFalse">Nem</label>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <label for="cim">A TDK-pályamunka címe</label>
                    <input type="text" id='cim' v-model="palyamunka.cim" class="form-control" required>
                </div>

                <div class="col-xs-2">
                    <label for="nyelv">Pályamunka nyelve</label>
                    <select id="nyelv" v-model="palyamunka.nyelv" class="form-control" title="Pályamunka nyelve" required>
                        <option value=""></option>
                        <option value="hu">magyar</option>
                        <option value="en">angol</option>
                        <option value="other">egyéb</option>
                    </select>
                </div>

                <div class="p-3 card mt-2">
                    <div class="col-xs-2">
                        <label for="otdkraJavasolt">Pályamunka affiliációja</label>
                        <div class="form-check" id="affiliacioTipusF">
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="affiliacioTipusF" value="F" v-model="palyamunka.affiliacioTipus" />
                                <label class="form-check-label" for="affiliacioTipusF">Felsőoktatási intézmény</label>
                            </div>
                            <div class="form-check form-check-inline">
                                <input class="form-check-input" type="radio" id="affiliacioTipusK" value="K" v-model="palyamunka.affiliacioTipus" />
                                <label class="form-check-label" for="affiliacioTipusK">Középiskolás program</label>
                            </div>
                        </div>
                    </div>

                    <div v-if="palyamunka.affiliacioTipus == 'F'">
                        <div class="col-xs-2">
                            <label for="intezmenyKod">Intézmény</label>
                            <select id="intezmenyKod" v-model="palyamunka.felsooktatasiAffiliacio.intezmenyKod" class="form-control" title="Az intézmény kódja, ahol a pályamunka elkészült" required>
                                <option value=""></option>
                                <option v-for="(intezmeny) in this.intezmenyek" :value="intezmeny.kod">{{ intezmeny.nev }}</option>
                            </select>
                        </div>

                        <div class="col-xs-2">
                            <label for="karKod">Kari szintű egység</label>
                            <select id="karKod" v-model="palyamunka.felsooktatasiAffiliacio.karKod" class="form-control" title="Az intézmény karának kódja, ahol a pályamunka elkészült">
                                <option value=""></option>
                                <option v-for="(kar) in this.availableKar()" :value="kar.kod">{{ kar.nev }}</option>
                            </select>
                        </div>
                    </div>
                    <div v-if="palyamunka.affiliacioTipus == 'K'">
                        <div class="form-group mb-1">
                            <label for="kozepiskolaProgram">Program megnevezése</label>
                            <select id="kozepiskolaProgram" v-model="palyamunka.kozepiskolaiAffiliacio.kozepiskolaProgram" class="form-control" title="A középiskolás program megnevezése" required>
                                <option value=""></option>
                                <option value="TUDOK">TUDOK (KDOSZ)</option>
                                <option value="ODN">Országos Diákvegyész Napok</option>
                                <option value="OKFD">Országos Középiskolai Földtudományi Diákkonferencia</option>
                                <option value="HJOKMD">Hlavay József Országos Környezettudományi és Műszaki Diákkonferencia</option>
                                <option value="OTIO">Országos Tudományos és Innovációs Olimpia</option>
                                <option value="MCCKOZ">MCC Középiskolás Ösztöndíjprogram Zárókonferencia</option>
                                <option value="EKKE">Tudományról Diákoknak Kíváncsiságból – Tehetségútlevél a felsőoktatásba (EKKE Tehetségútlevél)</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <label for="osszesitettPontszam">Összesített pontszám</label>
                    <input type="number" id='osszesitettPontszam' v-model="palyamunka.osszesitettPontszam" min="0" max="999" size="3" class="form-control w-25" title="Összesített pontszám" />
                </div>

                <div class="col-xs-2">
                    <label for="helyezes">Helyezés</label>
                    <select id="helyezes" v-model="palyamunka.helyezes" class="form-control" title="A kari konferencián elért helyezés (ha volt)">
                        <option value=""></option>
                        <option value="1">1</option>
                        <option value="2">2</option>
                        <option value="3">3</option>
                    </select>
                </div>

                <div class="col-xs-2">
                    <label for="zsuriMegjegyzes">Megjegyzés</label>
                    <input type="text" id='zsuriMegjegyzes' v-model="palyamunka.zsuriMegjegyzes" class="form-control" title="Zsűri megjegyzése" />
                </div>

                <div class="col-xs-2">
                    <label for="sorrendRelevans">Több szerző esetén a szerzők sorrendje releváns</label>
                    <div class="form-check" id="sorrendRelevans">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="sorrendRelevansTrue" value="true" v-model="palyamunka.sorrendRelevans" />
                            <label class="form-check-label" for="sorrendRelevansTrue">Igen <i>(megegyezik a szerzők jelen jegyzőkönyvben történt rögzítési sorrendjével)</i></label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="sorrendRelevansFalse" value="false" v-model="palyamunka.sorrendRelevans" />
                            <label class="form-check-label" for="sorrendRelevansFalse">Nem</label>
                        </div>
                    </div>
                </div>

                <div class="col-xs-2">
                    <label for="aranyRelevans">Több szerző esetén a szerzőségi arány releváns</label>
                    <div class="form-check" id="aranyRelevans">
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="aranyRelevansTrue" value="true" v-model="palyamunka.aranyRelevans" />
                            <label class="form-check-label" for="aranyRelevansTrue">Igen</label>
                        </div>
                        <div class="form-check">
                            <input class="form-check-input" type="radio" id="aranyRelevansFalse" value="false" v-model="palyamunka.aranyRelevans" />
                            <label class="form-check-label" for="aranyRelevansFalse">Nem</label>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div>
            <div class="card-separator">Szerző(k) adatai</div>
            <hallgato v-for="(hallgato, index) in palyamunka.szerzok" :hallgato="hallgato" :palyamunka="palyamunka" :index="index" />
        </div>
        <button class="btn btn-primary mb-2 btn-narrow" @click.prevent="addHallgato">Szerző felvétele</button>

        <div>
            <div class="card-separator">Témavezető(k) adatai</div>
            <temavezeto v-for="(temavezeto, index) in palyamunka.temavezetok" :temavezeto="temavezeto" :palyamunka="palyamunka" :index="index" />
        </div>
        <button class="btn btn-primary btn-narrow" @click.prevent="addTemavezeto">Témavezető felvétele</button>
    </div>
    <tr v-if="print">
        <th scope="row">
            <span class="pmtext">{{ index+1 }}</span>
        </th>
        <td>
            <span class="pmtext" v-for="(hallgato, index) in palyamunka.szerzok">{{ hallgato.vezetekNev }} {{ hallgato.keresztNev }}<br /></span>
        </td>
        <td>
            <span class="pmtext">{{ palyamunka.cim }}</span>
        </td>
        <td>
            <span class="pmtext" v-for="(temavezeto, index) in palyamunka.temavezetok">{{ temavezeto.titulus }} {{ temavezeto.vezetekNev }} {{ temavezeto.keresztNev }}<br /></span>
        </td>
        <td class="text-center">
            <span class="pmtext">{{ palyamunka.osszesitettPontszam ? palyamunka.osszesitettPontszam : ' ' }}</span>
        </td>
        <td class="text-center">
            <span class="pmtext">{{ palyamunka.helyezes ? palyamunka.helyezes : ' ' }}</span>
        </td>
        <td>
            {{ palyamunka.zsuriMegjegyzes }}
        </td>
        <td class="text-center">
            <span class="pmtext">{{ palyamunka.otdkraJavasolt == 'true' ? 'igen' : 'nem' }}</span>
        </td>
    </tr>
</template>

<script>
 import Hallgato from './Hallgato.vue'
 import Temavezeto from './Temavezeto.vue'

export default {
   	components: {
        Hallgato,
        Temavezeto
    },
	data() {
        return {
            intezmenyek: []
        }
    },
    props: ['palyamunka', 'index', 'print', 'jegyzokonyv'],
     async created() {
         this.intezmenyek = await this.$storage.getIntezmenyekAffiliacio();
    },
    methods: {
        addHallgato() {
            this.$storage.createHallgato(this.palyamunka);
        },
        addTemavezeto() {
            this.$storage.createTemavezeto(this.palyamunka);
        },
        availableKar() {
            var intezmenyKod = this.palyamunka.felsooktatasiAffiliacio.intezmenyKod;
            var intezmenyObj = this.intezmenyek.find((x) => x.kod == intezmenyKod);
            if (intezmenyObj)
                return intezmenyObj.karok;
            else
                return [];
        },
        deletePalyamunka() {
            const index = this.jegyzokonyv.palyamunkak.indexOf(this.palyamunka);
            if (index > -1)
                this.jegyzokonyv.palyamunkak.splice(index, 1);
        },
        upPalyamunka() {
            const index = this.jegyzokonyv.palyamunkak.indexOf(this.palyamunka);
            if (index > 0) {
                let tmp = this.jegyzokonyv.palyamunkak[index - 1];
                this.jegyzokonyv.palyamunkak[index - 1] = this.jegyzokonyv.palyamunkak[index];
                this.jegyzokonyv.palyamunkak[index] = tmp;
            }
        },
        downPalyamunka() {
            const index = this.jegyzokonyv.palyamunkak.indexOf(this.palyamunka);
            if (index < this.jegyzokonyv.palyamunkak.length) {
                let tmp = this.jegyzokonyv.palyamunkak[index + 1];
                this.jegyzokonyv.palyamunkak[index + 1] = this.jegyzokonyv.palyamunkak[index];
                this.jegyzokonyv.palyamunkak[index] = tmp;
            }
        }
    }
}
</script>

<style>
    .pmtext {
        text-align: center;
    }
</style>